'use client';
import React from 'react';
import { motion } from 'framer-motion';

const COLORS = {
  ACCENT_GOLD: '#faaf40',
  DARK_BG: '#101010',
  LIGHT_TEXT: '#f0f0f0',
};

export default function DietCtaSection() {
  return (
    <section
      className="relative py-24 text-center"
      style={{
        background: `linear-gradient(to bottom right, ${COLORS.DARK_BG}, #2c1b10, ${COLORS.ACCENT_GOLD})`,
        color: COLORS.LIGHT_TEXT,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-3xl mx-auto px-6"
      >
        <h2 className="text-5xl font-bold mb-6">
          Start Your <span style={{ color: COLORS.ACCENT_GOLD }}>Transformation</span> Today
        </h2>
        <p className="text-lg text-gray-300 mb-10">
          Join thousands of members already achieving balance, health, and confidence through Aura Diet Plans.
        </p>
        <button
          className="px-8 py-4 rounded-full font-semibold text-lg transition-all shadow-lg hover:scale-105"
          style={{
            backgroundColor: COLORS.ACCENT_GOLD,
            color: COLORS.DARK_BG,
          }}
        >
          Get Started Now
        </button>
      </motion.div>
    </section>
  );
}
